import { memo } from "react";
import { useLiveStreamAppContext } from "../ContextStore/Store";

//Following is Just a Layout Page for Low Internet Speed
function PoorConnectionError({ checkConnection }) {
  const { eventType } = useLiveStreamAppContext();
  return (
    <>
      <div className="poor-connection">
        <div className="poor-wrapper">
          <div className="poor-icon">
            <i className="icon font-awesome-light-pro va-connection"></i>
          </div>
          <h4 className="poor-title">Poor Network Connection</h4>
          <p className="poor-txt">
            There seems to be an issue, please reconnect back to the{" "}
            {eventType === 1 ? "appointment" : "class"}.
          </p>
          <button
            className="cbtn thm-btn reconnect-connection"
            onClick={checkConnection}
          >
            <span>Reconnect</span>
          </button>
        </div>
      </div>
    </>
  );
}
export default memo(PoorConnectionError);
